<template>
<div>
      <div id="loading">
      <img id="loading-resource"
           src="../../assets/images/loading.gif"
           alt="">
    </div>
  <canvas ref="canvas"
          id="therapy-canvas"
          width="1980"
          height="1080" />
</div>
</template>
<script>
import Therapy from '@therapy/therapy.js'

export default {
  data() {
    return {}
  },
  mounted: function() {
    window.therapy = new Therapy()
  },
  // updated() {
  //   this.$store.commit('setScenceSize')
  // }
}
</script>

<style rel="stylesheet/scss" lang="scss">
#therapy-canvas {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.34) 0px 4px 24px;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 100;
}
// .therapy-canvas {
//   width: 100%;
//   height: 100%;
// }
</style>


